import aksesControl from './access-control.js'

const accessControl = [...aksesControl]

export default accessControl
